/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ImageProcessingService {
  //private containerClient: ContainerClient;
  constructor(private http: HttpClient) {
    console.log("ImageProcessingService");
  }

  getDevlopmentBlobs(containerUrl: string, filterName: string): Observable<any[]> {
    const apiUrl = `${containerUrl}?restype=container&comp=list`;
    return this.http.get(apiUrl, { responseType: "text" }).pipe(
      map((response: string) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response, "text/xml");
        const blobElements = xmlDoc.getElementsByTagName("Blob");
        const filteredBlobNames: string[] = [];
        for (let i = 0; i < blobElements.length; i++) {
          const name = blobElements[i].getElementsByTagName("Name")[0].textContent ?? "";
          if (
            name.indexOf("/") > -1
              ? name.split("/")[0].toLocaleUpperCase() === filterName.toLocaleUpperCase()
              : false
          ) {
            filteredBlobNames.push(name);
          }
        }
        return filteredBlobNames;
      }),
    );
  }

  getProjectBlobPhotos(containerUrl: string, filterName: string): Observable<any[]> {
    const apiUrl = `${containerUrl}?restype=project&comp=list`;
    return this.http.get(apiUrl, { responseType: "text" }).pipe(
      map((response: string) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response, "text/xml");
        const blobElements = xmlDoc.getElementsByTagName("Blob");
        const filteredBlobNames: string[] = [];
        Array.from(blobElements).forEach((blobElement) => {
          const name = blobElement.getElementsByTagName("Name")[0].textContent ?? "";
          if (name.lastIndexOf(".") !== -1 && name.substring(0, name.lastIndexOf(".")).toLocaleUpperCase() === filterName.toLocaleUpperCase()) {
            filteredBlobNames.push(name);
          }
        });
        return filteredBlobNames;
      }),
    );
  }

  // getFilesAndFolders() {
  //   return this.http.get<string[]>('/assets/NYCHA/');
  //   // const filesAndFolders: string[] = [];
  //   // readdirSync(path).forEach((fileOrFolder) => {
  //   //   const fullPath = `${path}`;
  //   //   const stats = statSync(fullPath);
  //   //   if (stats.isDirectory()) {
  //   //     filesAndFolders.push(...this.getFilesAndFolders(fullPath));
  //   //   } else {
  //   //     filesAndFolders.push(fullPath);
  //   //   }
  //   // });

  //   // return filesAndFolders;
  // }
}
